import styled, { css } from 'styled-components';
import theme from '../../assets/styles/theme';

export const Popover = styled.div`
  display: inline-block;
`;

export const BasePopover = styled.div`
  z-index: 30;
  ${({ position }) => getPositionWrapper(position)}
`;

export const Wrapper = styled.div`
  will-change: transform;
  white-space: pre-wrap;
  min-width: 50px;
  width: max-content;
  max-width: 294px;
  border-radius: ${theme.spacing['spacing-2']};
  padding: ${theme.spacing['spacing-5']};
  background-color: ${theme.colors.neutral.bg.weak};
  box-shadow: ${theme.elevations['elevation-3']};
  display: flex;
`;

export const Content = styled.div``;
export const CloseButton = styled.div``;
export const ChildrenWrapper = styled.div``;

export const Arrow = styled.div`
  z-index: 12;
  position: absolute;
  display: block;
  border-style: solid;
  border-color: transparent;
  transform-origin: center bottom;
  ${({ position, width, height }) => getArrow(position, width, height)};
  ${({ position, width, height }) => getArrowPosition(position, width, height)};
`;

const getArrow = (position, width, height) => {
  let aux = position.indexOf('-');
  let positions;
  aux === -1 ? (positions = position) : (positions = position.slice(0, aux));
  return css`
    width: ${width};
    height: ${height};
    border-color: transparent;
    border-${positions}-color: ${theme.colors.neutral.bg.weak}`;
};

const getArrowPosition = (position, width, height) => {
  switch (position) {
    case 'top':
      return css`
        border-width: ${height} ${height} 0px ${height};
        bottom: calc(0% - ${height});
        left: calc(50% - ${width});
      `;
    case 'top-right':
      return css`
        border-width: ${height} ${height} 0px ${height};
        bottom: calc(0% - ${height});
        right: calc(0% + ${width});
      `;
    case 'top-left':
      return css`
        border-width: ${height} ${height} 0px ${height};
        bottom: calc(0% - ${height});
        left: calc(0% + ${width});
      `;
    case 'bottom':
      return css`
        border-width: 0px ${height} ${height} ${height};
        top: calc(0% - ${height});
        left: calc(50% - ${width});
      `;
    case 'bottom-left':
      return css`
        border-width: 0px ${height} ${height} ${height};
        top: calc(0% - ${height});
        left: calc(0% + ${width});
      `;
    case 'bottom-right':
      return css`
        border-width: 0px ${height} ${height} ${height};
        top: calc(0% - ${height});
        right: calc(0% + ${width});
      `;
    case 'right':
      return css`
        border-width: ${height} ${height} ${height} 0px;
        top: calc(50% - ${height});
        left: calc(0% - ${width});
      `;
    case 'left':
      return css`
        border-width: ${height} 0px ${height} ${height};
        top: calc(50% - ${height});
        right: calc(0% - ${width});
      `;
  }
};

const getPositionWrapper = (position) => {
  switch (position) {
    case 'top':
    case 'top-left':
    case 'top-right':
      return css`
        padding: ${theme.spacing['spacing-0']} ${theme.spacing['spacing-0']}
          ${theme.spacing['spacing-3']} ${theme.spacing['spacing-0']};
      `;
    case 'bottom':
    case 'bottom-left':
    case 'bottom-right':
      return css`
        padding: ${theme.spacing['spacing-3']} ${theme.spacing['spacing-0']}
          ${theme.spacing['spacing-0']} ${theme.spacing['spacing-0']};
      `;
    case 'right':
      return css`
        padding: ${theme.spacing['spacing-0']} ${theme.spacing['spacing-0']}
          ${theme.spacing['spacing-0']} ${theme.spacing['spacing-3']};
      `;
    case 'left':
      return css`
        padding: ${theme.spacing['spacing-0']} ${theme.spacing['spacing-3']}
          ${theme.spacing['spacing-0']} ${theme.spacing['spacing-0']};
      `;
  }
};
